var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 42,
    viewBox: "0 0 56 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 42,
    rx: 12,
    fill: "#006B6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0725 13.4104C17.6533 11.7336 19.4149 10.3505 20.9443 11.1555L37.9663 20.1144C38.2948 20.2874 38.5005 20.6281 38.5005 20.9994C38.5005 21.3706 38.2948 21.7114 37.9663 21.8843L20.9443 30.8432C19.4149 31.6482 17.6533 30.2651 18.0725 28.5883L19.9698 20.9994L18.0725 13.4104ZM21.7813 21.9994L20.0128 29.0734L33.4535 21.9994H21.7813ZM33.4535 19.9994H21.7813L20.0128 12.9253L33.4535 19.9994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendButton);
export default __webpack_public_path__ + "static/media/ic_send-button.653c95da970485b6f192feb5f8c14d9f.svg";
export { ForwardRef as ReactComponent };